export default __webpack_public_path__ + "static/lausd-logo-f20d3a82810c09e9419c2c3177aaf99d.svg";